import { AppUser } from 'Src/views/App/App';
import axios from 'axios';
import { ALL_LIMIT } from 'Src/consts/table';

export function getPhotoTypes(user: AppUser, filter) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter,
    },
  };

  return axios
    .get(`${window.apiBase}/admin/photoTypes`, config)
    .then(response => {
      return response.data;
    });
}

export function getAllPhotoTypes(user: AppUser, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where,
          },
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          limit: ALL_LIMIT,
          skip: 0,
        },
      },
    };
  }

  return axios
    .get(`${window.apiBase}/admin/photoTypes`, config)
    .then(response => {
      return response.data;
    });
}

export function getPhotoTypesCount(user: AppUser, where?) {
  const { sessionKey: key } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: where,
        },
      },
    };
  } else {
    config = {
      headers: { usid: key },
    };
  }

  return axios
    .get(`${window.apiBase}/admin/photoTypes/count`, config)
    .then(response => {
      return response.data;
    });
}

export function addPhotoType(user: AppUser, data) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .post(`${window.apiBase}/admin/photoTypes`, data, config)
    .then(response => {
      return response.data;
    });
}

export function updatePhotoType(user: AppUser, photoTypeId: string, data) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .put(`${window.apiBase}/admin/photoTypes/${photoTypeId}`, data, config)
    .then(response => {
      return response.data;
    });
}

export function deletePhotoType(user: AppUser, photoTypeId: string) {
  const { sessionKey: key } = user;

  const config = {
    headers: { usid: key },
  };

  return axios
    .delete(`${window.apiBase}/admin/photoTypes/${photoTypeId}`, config)
    .then(response => {
      return response.data;
    });
}
